import createClient from 'openapi-fetch';
function withAuth(options) {
    const { accessToken, ...rest } = options;
    return {
        ...rest,
        headers: {
            ...rest.headers,
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
    };
}
export function createBusinessClient(options) {
    return createClient(withAuth(options));
}
export function createCustomerClient(options) {
    return createClient(withAuth(options));
}
export function createMerchantClient(options) {
    return createClient(withAuth(options));
}
export function createAdminClient(options) {
    return createClient(withAuth(options));
}
export function createPartnerClient(options) {
    return createClient(withAuth(options));
}
export function createInternalClient(options) {
    return createClient(withAuth(options));
}
export function createPlatformClient(options) {
    return createClient(withAuth(options));
}
/** SDK version aligned with OpenAPI info.version */
export const SDK_VERSION = '1.0.0';
//# sourceMappingURL=index.js.map